import Component from 'vue-class-component'
import Vue, { CreateElement } from 'vue'
import { Prop } from 'vue-property-decorator'

import { Divider } from '@src/elements/divider/divider'

import './content-box.sass'

// card with rounded corners, fixed bottom and visible/scrollable content
@Component
export class ContentBox extends Vue {

  @Prop({ required: false, default: 'visible' })
  overflow: 'scrollable' | 'visible'

  render (h: CreateElement) {
    return (
      <div class={`content-box ${this.overflow}`}>
        <div class={`scroll-content content-box-body ${this.overflow}`} ref='contentBoxBody' id='content-box-body'>
          {this.$slots.content}
        </div>

        {this.$slots.bottom ? <Divider /> : null}

        {this.$slots.bottom ?
          <div class='content-box-bottom'>
            {this.$slots.bottom}
          </div> : null}

      </div>
    )
  }
}
